import React from "react";
import Pagination from "react-js-pagination";
import TableBack from "../../assets/Images/Icons/pagination_back.png";
import TableNext from "../../assets/Images/Icons/pagination_forward.png";
import "./style.css";

const RenderPagination = ({ handlePageChange, Page, data, totalLength }) => {
  const handleClick = (e) => {
    handlePageChange(e);
  };
  return (
    <>
      <div className="Pro-Pagination">
        <Pagination
          itemClassNext={"next-arrow"}
          itemClassPrev={"prev-arrow"}
          prevPageText={<img src={TableBack} />}
          nextPageText={<img src={TableNext} />}
          activePage={Page}
          hideFirstLastPages={true}
          onChange={handleClick}
          itemClass="page-item"
          linkClass="page-link"
          itemsCountPerPage={totalLength / totalLength}
          totalItemsCount={totalLength ? totalLength : 1}
          pageRangeDisplayed={3}
        />
      </div>
    </>
  );
};

export default RenderPagination;
